import {domainIncidentAPI} from 'features/domain/api/domainIncidentAPI';
import {getDomainRobotsTxtUrl} from 'features/domain/lib/domainMonitorView';
import {iriToId} from 'shared/api/iriHelper';

import IDomainIncident from './DomainIncident/IDomainIncident';

const ROBOTS_DIFF_TYPE = 'robots-txt-differs-from-expected';

export const useDomainIncident = (item: IDomainIncident) => {
    const isRobotsDiff = item.type === ROBOTS_DIFF_TYPE;

    const {data: diffData, isLoading: isLoadingDiff} = domainIncidentAPI.useGetDomainIncidentDiffQuery(
        item.id,
        {skip: !isRobotsDiff},
    );

    const [saveExpected, {isLoading: isSaving, isSuccess: isSaved}] =
        domainIncidentAPI.useSaveExpectedRobotsMutation();

    const openRobotsTxt = () => {
        const url = getDomainRobotsTxtUrl(window.location.protocol, item.domain);
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    const saveExpectedRobots = async() => {
        await saveExpected(item.id).unwrap();
    };

    return {
        isRobotsDiff,
        diffData,
        isLoadingDiff,
        isSaving,
        isSaved,
        domainMonitorId: iriToId(item.domain_monitor),
        openRobotsTxt,
        saveExpectedRobots,
    };
};

export default useDomainIncident;
